import React, { useState, useEffect } from "react";

function AddCourseForm(props) {
  const [courseName, setCourseName] = useState("");
  const [creditHours, setCreditHours] = useState("");
  const [grade, setGrade] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    if (grade.length > 0) {
      const newGrade = { courseName, creditHours, grade };
      props.addGrade(newGrade);
      setCourseName("");
      setCreditHours("");
      setGrade("");
    }
  }

  return (
    <div className="formContainer">
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Subject Name"
          value={courseName}
          onChange={(e) => setCourseName(e.target.value)}
          required
        />
        <input
          type="number"
          placeholder="Credit"
          value={creditHours}
          onChange={(e) => setCreditHours(e.target.value)}
          required
        />
        <select
          required
          value={grade}
          onChange={(e) => setGrade(e.target.value)}
        >
          <option>grade</option>
          <option grade="A+">A+</option>
          <option grade="A">A</option>
          <option grade="B+">B+</option>
          <option grade="B">B</option>
          <option grade="C+">C+</option>
          <option grade="C">C</option>
          <option grade="D">D</option>
          <option grade="E">E</option>
          <option grade="F">F</option>
          <option grade="I">I</option>
        </select>

        <button type="submit" className="button">
          Add Course
        </button>
      </form>
    </div>
  );
}

export default AddCourseForm;
